import { Component, ComponentFactoryResolver, ChangeDetectorRef } from '@angular/core';
import { ListLayoutSingleComponent } from 'gung-list';

@Component({
    selector: 'ref-ref-cart-list-layout',
    templateUrl: './ref-cart-list-layout.component.html',
    styleUrls: ['./ref-cart-list-layout.component.scss'],
    standalone: false
})
export class RefCartListLayoutComponent<T> extends ListLayoutSingleComponent<T> {

}
